<template>
<div class="vipPrivilege-wrap"> 
  <div class="vipPrivilege">
    <div class="privileges">
      <div class="section-header">
        <h2 class="section-title">VIP尊享特权</h2>
      </div>
      <div class="vip-level-outer-container">
        <div class="vip-level-inner-container">
          <div class="vip-level-table" v-if="vipLis.length > 0" ref="vipLevelTable">
            <div class="vip-level-item" 
                 v-for="(level, index) in 10" 
                 :key="index"
                 :class="{ 
                   'current-level': index + 1 === currentVipLevel,
                   'unreachable': index >= userUnlockedLevel
                 }"
                 :ref="index + 1 === currentVipLevel ? 'currentVipRef' : null"
                 @click="handleLevelClick(index + 1)">
              <span class="level-number">VIP{{ index + 1 }}</span>
              <span class="level-name">{{ getLevelName(index) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="current-vip-card" v-if="currentVipInfo" ref="currentVipCard">
        <div class="vip-badge">
          <div class="vip-icon" :style="{ backgroundColor: getCurrentVipColor() }">
            VIP{{ currentVipLevel }}
          </div>
          <div class="vip-info">
            <div class="vip-level">{{ currentVipInfo.name }}</div>
            <div class="vip-status">当前等级</div>
          </div>
        </div>
        <div class="vip-progress">
          <div class="progress-header">
            <span>升级进度</span>
            <span class="progress-percent">{{ currentVipInfo.progress }}%</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" 
                 :style="{ 
                   width: currentVipInfo.progress + '%',
                   backgroundColor: getCurrentVipColor()
                 }"></div>
          </div>
          <div class="progress-label">
            <template v-if="currentVipInfo.isHighestLevel">
              已达到最高等级
            </template>
            <template v-else>
              距离升级至<span class="highlight">{{ currentVipInfo.nextName }}</span>:
              <div class="progress-details">
                <span v-if="currentVipInfo.rechargeStatus === 'satisfied'">
                  <i class="fas fa-check-circle"></i> 充值已满足
                </span>
                <span v-else>
                  <i class="fas fa-coins"></i> 还需充值 {{ currentVipInfo.rechargeNeed }} 元
                </span>
                <span v-if="currentVipInfo.flowStatus === 'satisfied'">
                  <i class="fas fa-check-circle"></i> 流水已满足
                </span>
                <span v-else>
                  <i class="fas fa-exchange-alt"></i> 还需流水 {{ currentVipInfo.flowNeed }} 元
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="vipLis.length > 0" class="vip-table-container" ref="tableContainer">
      <div class="table-header" :class="{ 'sticky-header': isHeaderSticky }" ref="tableHeader">
        <div class="table-cell level-cell">VIP等级详情</div>
        <div class="data-rows">
          <div class="data-row first-row">
            <div class="table-cell">累计充值</div>			  
            <div class="table-cell">累计流水</div>
            <div class="table-cell">真人返水</div>
            <div class="table-cell">电子返水</div>
          </div>
          <div class="data-row second-row">
            <div class="table-cell">棋牌返水</div>
            <div class="table-cell">体育返水</div>
            <div class="table-cell">彩票返水</div>
            <div class="table-cell">电竞返水</div>
          </div>
        </div>
      </div>
      <div class="vip-row" 
           v-for="(item, index) in vipLis" 
           :key="index" 
           :class="{ 'current-vip-row': index === currentVipLevel - 1 }"
           :style="{ 
             borderColor: getLevelColor(index),
             borderWidth: index === currentVipLevel - 1 ? '2px' : '1px'
           }">
        <div class="table-cell level-cell">
          <div class="level-info">
            <span class="level-title">VIP{{ index + 1 }}</span>
          </div>
        </div>
        <div class="data-rows">
          <div class="data-row first-row">
            <div class="table-cell" style="font-size: 12px;font-weight: 700;color: red;">{{ formatNumber(item.recharge) }}</div>			  
            <div class="table-cell" style="font-size: 12px;font-weight: 700;color: red;">{{ formatNumber(item.flow) }}</div>
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.realperson }}%</div>
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.electron }}%</div>
          </div>
          <div class="data-row second-row">
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.joker }}%</div>
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.sport }}%</div>
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.lottery }}%</div>
            <div class="table-cell highlight" :style="{ color: getLevelColor(index) }">{{ item.e_sport }}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-state" v-else>
      <div class="empty-icon">
        <i class="fas fa-trophy"></i>
      </div>
      <p class="empty-title">暂无VIP特权数据</p>
      <p class="empty-subtitle">完成更多任务即可解锁VIP等级</p>
      <button class="empty-action">查看升级攻略</button>
    </div>
  </div>
  <div style="height: 60px"></div>
</div>
</template>

<script>
const vipNameMap = {
  VIP1: '青铜会员', VIP2: '白银会员', VIP3: '黄金会员',
  VIP4: '铂金会员', VIP5: '钻石会员', VIP6: '星耀会员',
  VIP7: '王者会员', VIP8: '荣耀会员', VIP9: '至尊会员',
  VIP10: '传奇会员'
};	
export default {
  name: 'VipPrivilege',
  data() {
    return { 
      vipLis: [],
      currentVipLevel: this.$store.state.userInfo.vip || 1, // 当前VIP等级
      userMaxVipLevel: this.$store.state.userInfo.vip || 1,
      currentVipInfo: null, // 当前VIP信息
      userData: {
        currentRecharge: Number(this.$store.state.userInfo.paysum) || 0, // 用户当前累计充值
        currentFlow: Number(this.$store.state.userInfo.totalgame) || 0 // 用户当前累计流水
      },
      isHeaderSticky: false, // 表头是否固定
      headerOffsetTop: 0, // 表头距离顶部的距离
      scrollHandler: null // 滚动事件处理器
    };
  },
  computed: {
    userUnlockedLevel() {
      return Math.max(this.userMaxVipLevel, 0);
    }
  },
  updated() {
    this.scrollToCurrentVip();
  },
  mounted() {
    this.uservip();
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        this.calculateHeaderPosition();
      });
    });
  },
  beforeDestroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  },
  methods: {
    uservip() {
      const that = this;
      if (that.$parent && typeof that.$parent.showLoading === 'function') {
        that.$parent.showLoading();
      }
      that.$apiFun.post('/api/uservip', {}).then(res => {
        if (res.code === 200) {
          const vipList = res.data || [];
          that.vipLis = vipList.map(item => ({
            flow: Number(item.flow),
            recharge: Number(item.recharge),
            realperson: item.realperson,
            electron: item.electron,
            joker: item.joker,
            sport: item.sport,
            lottery: item.lottery,
            e_sport: item.e_sport,
            name: vipNameMap[item.vipname] || item.vipname
          }));
          that.calculateProgress();
          that.$nextTick(() => {
            that.calculateHeaderPosition();
            that.initScrollListener();
            that.$forceUpdate(); // 强制更新UI确保未解锁状态正确显示
          });
        } else {
          that.$parent.showTost(0, res.message);
        }
      }).catch(() => {
        if (that.$parent && typeof that.$parent.hideLoading === 'function') {
          that.$parent.hideLoading();
        }
      }).finally(() => {
        if (that.$parent && typeof that.$parent.hideLoading === 'function') {
          that.$parent.hideLoading();
        }
      });
    },
    calculateProgress() {
      if (this.vipLis.length === 0) return;
      const currentIndex = this.currentVipLevel - 1;
      const currentVip = this.vipLis[currentIndex] || this.vipLis[0];
      const nextVip = this.vipLis[currentIndex + 1] || null;
      const isHighestLevel = !nextVip;
      if (isHighestLevel) {
        this.currentVipInfo = {
          name: currentVip.name,
          progress: 100,
          isHighestLevel: true
        };
        return;
      }
      const rechargeNeed = Math.max(0, nextVip.recharge - this.userData.currentRecharge);
      const rechargeStatus = this.userData.currentRecharge >= nextVip.recharge ? 'satisfied' : 'needed';
      const flowNeed = Math.max(0, nextVip.flow - this.userData.currentFlow);
      const flowStatus = this.userData.currentFlow >= nextVip.flow ? 'satisfied' : 'needed';
      const currentVipRecharge = currentVip.recharge;
      const currentVipFlow = currentVip.flow;
      const rechargeProgress = currentVipRecharge >= nextVip.recharge 
        ? 100  // 当前等级充值要求已高于下一级，直接视为满足
        : this.userData.currentRecharge >= nextVip.recharge
          ? 100  // 已满足充值要求
          : Math.round(((this.userData.currentRecharge - currentVipRecharge) / (nextVip.recharge - currentVipRecharge)) * 100);
      const flowProgress = currentVipFlow >= nextVip.flow
        ? 100  // 当前等级流水要求已高于下一级，直接视为满足
        : this.userData.currentFlow >= nextVip.flow
          ? 100  // 已满足流水要求
          : Math.round(((this.userData.currentFlow - currentVipFlow) / (nextVip.flow - currentVipFlow)) * 100);
      const overallProgress = Math.max(0, Math.min(rechargeProgress, flowProgress));
      this.currentVipInfo = {
        name: currentVip.name,
        nextName: nextVip.name,
        progress: overallProgress,
        isHighestLevel: false,
        rechargeNeed: rechargeNeed,
        rechargeStatus: rechargeStatus,
        flowNeed: flowNeed,
        flowStatus: flowStatus
      };
    },
    scrollToCurrentVip() {
      if (this.$refs.currentVipRef && this.$refs.currentVipRef[0] && this.$refs.vipLevelTable) {
        const container = this.$refs.vipLevelTable;
        const currentItem = this.$refs.currentVipRef[0];
        const containerRect = container.getBoundingClientRect();
        const itemRect = currentItem.getBoundingClientRect();
        const scrollPosition = currentItem.offsetLeft - (containerRect.width / 2) + (itemRect.width / 2);
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    },
    calculateHeaderPosition() {
      if (this.$refs.tableHeader) {
        const rect = this.$refs.tableHeader.getBoundingClientRect();
        this.headerOffsetTop = rect.top + window.pageYOffset;
      }
    },
    initScrollListener() {
      this.scrollHandler = () => {
        if (window.pageYOffset >= this.headerOffsetTop) {
          this.isHeaderSticky = true;
        } else {
          this.isHeaderSticky = false;
        }
      };
      this.scrollHandler(); // 初始检查
      window.addEventListener('scroll', this.scrollHandler);
    },
    getLevelColor(index) {
      const colors = [
        '#9E9E9E', // VIP1 - 灰色
        '#4CAF50', // VIP2 - 绿色
        '#2196F3', // VIP3 - 蓝色
        '#FFC107', // VIP4 - 黄色
        '#FF9800', // VIP5 - 橙色
        '#FF5252', // VIP6 - 红色
        '#9C27B0',  // VIP7 - 紫色
        '#673AB7',  // VIP8 - 深紫
        '#3F51B5',  // VIP9 - 靛蓝
        '#03A9F4'   // VIP10 - 亮蓝
      ];
      return colors[index] || colors[colors.length - 1];
    },
    getCurrentVipColor() {
      return this.getLevelColor(this.currentVipLevel - 1);
    },
    formatNumber(num) {
       return String(Math.floor(Number(num)));
    },
    getLevelName(index) {
      if (index < this.userUnlockedLevel) {
        return (this.vipLis[index] && this.vipLis[index].name) || vipNameMap[`VIP${index + 1}`];
      }
      return "未解锁";
    },
    handleLevelClick(level) {
      if (level <= this.userUnlockedLevel) {
        this.currentVipLevel = level;
        this.calculateProgress();
        this.$nextTick(() => {
          this.scrollToCurrentVip();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$white: #ffffff;
$gray-50: #f9fafb;
$gray-100: #f3f4f6;
$gray-200: #e5e7eb;
$gray-300: #d1d5db;
$gray-400: #9ca3af;
$gray-600: #4b5563;
$gray-800: #1f2937;
$primary: #3b82f6;
$primary-light: #eff6ff;
$shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
$shadow-hover: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
$transition: all 0.3s ease;
$radius: 16px;
$card-radius: 12px;
.vipPrivilege-wrap {
  background-color: $gray-50;
  min-height: 100vh;
  padding: 30px 0;
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(59, 130, 246, 0.03) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(59, 130, 246, 0.03) 0%, transparent 20%);
}
.vipPrivilege {
  width: 94%;
  max-width: 1200px;
  margin: 0 auto;
  background: $white;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    background: linear-gradient(90deg, 
      #9E9E9E 0%, 
      #4CAF50 10%, 
      #2196F3 20%, 
      #FFC107 30%, 
      #FF9800 40%, 
      #FF5252 50%, 
      #9C27B0 60%,
      #673AB7 70%,
      #3F51B5 80%,
      #03A9F4 100%);
  }
}
.vip-level-outer-container {
  overflow: hidden;
  margin: 0 8px;
  padding-bottom: 5px; 
}
.vip-level-inner-container {
  width: 100%;
  overflow-x: hidden;
}
.vip-level-table {
  display: flex;
  overflow-x: auto;
  padding: 15px 0;
  gap: 10px;
  border-bottom: 1px solid $gray-100;
  background-color: $gray-50;
  scroll-behavior: smooth;
  width: calc(100% + 30px);
  padding-left: 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  .vip-level-item {
    flex: 0 0 auto;
    padding: 12px 18px;
    background-color: $white;
    border-radius: 8px;
    border: 1px solid $gray-200;
    cursor: pointer;
    transition: $transition;
    min-width: 100px;
    text-align: center;
    &:hover {
      transform: translateY(-3px);
      box-shadow: $shadow;
      border-color: $primary;
    }
    &.current-level {
      border-color: $primary;
      background-color: $primary-light;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
      font-weight: 600;
      transform: scale(1.05);
    }
    &.unreachable {
      opacity: 0.6;
      cursor: not-allowed;
      background-color: $gray-100;
      border-color: $gray-300;
      &:hover {
        transform: none;
        box-shadow: none;
        border-color: $gray-300;
      }
      &::after {
        content: "🔒";
        display: block;
        margin-top: 4px;
        font-size: 14px;
      }
      .level-name {
        color: $gray-400;
      }
    }
    .level-number {
      display: block;
      font-weight: 700;
      margin-bottom: 4px;
    }
    .level-name {
      font-size: 13px;
      color: $gray-600;
    }
  }
}
.section-header {
  padding: 30px 0;
  text-align: center;
  position: relative;
  .section-title {
    font-size: 28px;
    font-weight: 700;
    color: $gray-800;
    position: relative;
    display: inline-block;
    padding-bottom: 12px;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 4px;
      background: $primary;
      border-radius: 2px;
    }
  }
}
.current-vip-card {
  background: linear-gradient(135deg, $primary-light 0%, #03A9F4  100%);
  border-radius: $card-radius;
  margin: 0 2px 30px !important; /* 加大数值更容易观察 */
  padding: 20px !important;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  box-shadow: $shadow;
  border: 1px solid rgba(59, 130, 246, 0.2);
  transition: $transition;
  &:hover {
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.12);
  }
  .vip-badge {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
    .vip-icon {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 700;
      color: white;
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
      transition: $transition;
      &:hover {
        transform: scale(1.05);
      }
    }
    .vip-info {
      display: flex;
      flex-direction: column;
      .vip-level {
        font-size: 24px;
        font-weight: 700;
        color: $primary;
      }
      .vip-status {
        background: rgba(59, 130, 246, 0.1);
        color: $primary;
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 500;
        margin-top: 5px;
        align-self: flex-start;
      }
    }
  }
  .vip-progress {
    flex: 2;
    padding-left: 20px;
    .progress-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 16px;
      color: $gray-600;
      .progress-percent {
        font-weight: 700;
        color: $primary;
      }
    }
    .progress-bar {
      height: 12px;
      background: rgba(59, 130, 246, 0.15);
      border-radius: 6px;
      overflow: hidden;
      margin-bottom: 10px;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
    }
    .progress-fill {
      height: 100%;
      border-radius: 6px;
      box-shadow: 0 0 10px rgba(37, 99, 235, 0.4);
      position: relative;
      transition: width 1s ease;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.1) 50%,
          transparent 50%
        );
        background-size: 20px 20px;
        animation: shimmer 2s infinite linear;
      }
    }
    .progress-label {
      font-size: 14px;
      color: $gray-600;
      line-height: 1.6;
      .highlight {
        color: $primary;
        font-weight: 600;
      }
      .progress-details {
        display: flex;
        flex-wrap: wrap;
        gap: 5px 10px;
        margin-top: 5px;
        i {
          margin-right: 5px;
        }
        span:first-child {
          color: #e91e63; // 充值相关颜色
        }
        span:last-child {
          color: #673AB7; // 流水相关颜色
        }
      }
    }
  }
}
.vip-table-container {
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 30px;
}
.table-header {
  display: flex;
  background-color: $gray-100;
  font-weight: 600;
  border-bottom: 2px solid $gray-200;
  z-index: 10;
  transition: $transition;
  &.sticky-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: calc(94% - 2px);
    max-width: 1200px;
    margin: 0 auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    animation: headerSlideDown 0.3s ease forwards;
  }
  .level-cell {
    flex: 0 0 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-right: 1px solid $gray-200;
  }
  .data-rows {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .data-row {
    display: flex;
    flex: 1;
    &.first-row {
      border-bottom: 1px solid $gray-200;
    }
    .table-cell {
      flex: 1;
      padding: 16px 12px;
      text-align: center;
      border-right: 1px solid $gray-200;
      color: $gray-800;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.vip-row {
  display: flex;
  background-color: $white;
  border-bottom: 1px solid $gray-100;
  transition: $transition;
  position: relative;
  border-style: solid;
  border-radius: 8px;
  margin: 5px;
  &:first-child {
    transition: $transition;
    .table-header.sticky-header ~ & {
      margin-top: 130px;
    }
  }
  &:hover {
    background-color: $gray-50;
    transform: translateX(4px);
  }
  &.current-vip-row {
    background-color: $primary-light;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    &::after {
      content: '当前等级';
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      background: currentColor;
      color: white;
      font-size: 12px;
      padding: 4px 10px;
      border-radius: 12px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }
  .level-cell {
    flex: 0 0 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 12px;
    border-right: 1px solid $gray-100;
  }
  .level-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .level-title {
    font-weight: 500;
    color: $gray-800;
    font-size: 14px;
  }
  .data-rows {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .data-row {
    display: flex;
    flex: 1;
    &.first-row {
      border-bottom: 1px dashed $gray-200;
    }
    .table-cell {
      flex: 1;
      padding: 16px 12px;
      text-align: center;
      font-size: 15px;
      color: $gray-600;
      border-right: 1px solid $gray-100;
      &:last-child {
        border-right: none;
      }
      &.highlight {
        font-weight: 600;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 2px;
          background-color: currentColor;
          transition: width 0.3s ease;
        }
        &:hover::after {
          width: 60%;
        }
      }
    }
  }
}
.empty-state {
  padding: 90px 20px;
  text-align: center;
  color: $gray-400;
  .empty-icon {
    width: 110px;
    height: 110px;
    margin: 0 auto 28px;
    background-color: $gray-50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: $transition;
    &:hover {
      transform: scale(1.05);
    }
    i {
      font-size: 52px;
      color: $gray-300;
    }
  }
  .empty-title {
    font-size: 20px;
    font-weight: 600;
    color: $gray-600;
    margin-bottom: 10px;
  }
  .empty-subtitle {
    font-size: 15px;
    color: $gray-400;
    margin-bottom: 28px;
  }
  .empty-action {
    background-color: $primary;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 28px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: $transition;
    &:hover {
      background-color: #2563eb;
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(59, 130, 246, 0.2);
    }
  }
}
@media (max-width: 992px) {
  .table-header .level-cell,
  .vip-row .level-cell {
    flex: 0 0 150px;
  }
  .data-row .table-cell {
    font-size: 14px;
    padding: 14px 8px;
  }
  .table-header.sticky-header ~ .vip-row:first-child {
    margin-top: 110px;
  }
}
@media (max-width: 768px) {
  .current-vip-card {
    flex-direction: column;
    text-align: center;
    padding: 20px;
    gap: 20px;
  }
  .vip-progress {
    padding-left: 0;
    padding-top: 20px;
    border-left: none;
    border-top: 1px solid rgba(59, 130, 246, 0.2);
    width: 100%;
  }
  .vip-badge {
    justify-content: center;
  }
  .vip-status {
    align-self: center !important;
  }
  .table-header, .vip-row {
    flex-direction: column;
  }
  .table-header .level-cell,
  .vip-row .level-cell {
    flex: none;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid $gray-200;
    padding: 12px;
  }
  .data-rows {
    width: 100%;
  }
  .current-vip-row {
    border-radius: 8px;
    margin: 5px;
  }
  .current-vip-row::after {
    display: none;
  }
  .section-title {
    font-size: 24px !important;
  }
  .table-header.sticky-header {
    width: calc(94% - 2px);
  }
  .table-header.sticky-header ~ .vip-row:first-child {
    margin-top: 160px;
  }
}
@media (max-width: 576px) {
  .data-row {
    flex-wrap: wrap;
  }
  .data-row .table-cell {
    flex: 0 0 50%;
    padding: 10px 5px;
    font-size: 13px;
    border-bottom: 1px solid $gray-100;
  }
  .data-row.first-row .table-cell:nth-child(odd),
  .data-row.second-row .table-cell:nth-child(odd) {
    border-right: 1px solid $gray-100;
  }
  .vipPrivilege-wrap {
    padding: 20px 0;
  }
  .current-vip-card {
    padding: 16px;
    margin: 0 15px 24px;
  }
  .vip-icon {
    width: 64px !important;
    height: 64px !important;
    font-size: 24px !important;
  }
  .vip-level {
    font-size: 22px !important;
  }
  .progress-label {
    font-size: 13px !important;
  }
  .vip-level-item {
    min-width: 80px;
    padding: 8px 12px;
    .level-number {
      font-size: 14px;
    }
    .level-name {
      font-size: 12px;
    }
  }
  .table-header.sticky-header ~ .vip-row:first-child {
    margin-top: 140px;
  }
}
@keyframes shimmer {
  0% {
    background-position: -40px 0;
  }
  100% {
    background-position: 40px 0;
  }
}
@keyframes headerSlideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/vip.vue